import React from "react";
import { serializeJsonLd } from "~/lib/structuredData";

import clsx from "clsx";

import QuoteEndSVG from "~/assets/images/quote-end.svg";
import QuoteStartSVG from "~/assets/images/quote-start.svg";
import Image from "~/common/components/CustomImage";

import styles from "./TestimonialCard.module.scss";

export const TestimonialContent = ({ className, quote, logo, name, role, company }) => (
  <div className={clsx(styles.content, className)}>
    {quote && name && (
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: serializeJsonLd({
        "@context": "https://schema.org",
        "@type": "Review",
        reviewBody: quote,
        author: { "@type": "Person", name, jobTitle: role,
          ...(company ? { worksFor: { "@type": "Organization", name: company } } : {}) },
        itemReviewed: { "@type": "SoftwareApplication", "@id": "https://palmate.ai#software", name: "Palmate AI" },
      }) }} />
    )}
    <QuoteStartSVG className={styles.quoteIconStart} />
    <p className={styles.quote}>
      {quote}
      <QuoteEndSVG className={styles.quoteIconEnd} />
    </p>

    <div className={styles.footer}>
      <div className={styles.logoWrapper}>
        <Image src={logo} alt={company} width={90} height={38} />
      </div>
      <div className={styles.divider} />
      <div className={styles.userInfo}>
        <p className={styles.userName}>{name}</p>
        <p className={styles.userRole}>{role}</p>
      </div>
    </div>
  </div>
);

export default function TestimonialCard({ avatar, ...contentProps }) {
  return (
    <div className={styles.card}>
      <div className={styles.imageWrapper}>
        <Image src={avatar} alt={contentProps.name} fill />
      </div>
      <TestimonialContent {...contentProps} />
    </div>
  );
}
